// Copyright 2025, compose-coui-ui contributors
// SPDX-License-Identifier: Apache-2.0
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableFloatStateOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import io.github.suqi8.coui.kmp.basic.RangeSlider
import io.github.suqi8.coui.kmp.basic.Slider

@Composable
fun SliderDemo() {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(demoBackground()),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            Modifier
                .padding(16.dp)
                .widthIn(max = 600.dp)
                .fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(16.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            var slider1 by remember { mutableFloatStateOf(0.5f) }
            var slider2 by remember { mutableFloatStateOf(0.7f) }
            var slider3 by remember { mutableStateOf(0.2f..0.8f) }
            Slider(
                value = slider1,
                onValueChange = { slider1 = it },
            )
            Slider(
                value = slider2,
                onValueChange = { slider2 = it },
                enabled = false,
            )
            RangeSlider(
                value = slider3,
                onValueChange = { slider3 = it },
            )
        }
    }
}
